import WebApi from '@/views/loyalty/shared/modules/web_api'
import { unwrapEnvelope, envelopeError } from '@/views/skud/shared/modules/skud-http'

// БРСК-группа Charon: GET brsk (факт привязки), bind, replace-apikey (api_doc.md, 2026-08-25).
export class SkudBrskEndpoint {
  constructor () {
    this.url = `${process.env.VUE_APP_CHARON_URL}api/management/`
    this.webApi = new WebApi()
  }

  // -> {bound: Boolean} | null (ошибка/нет эндпоинта — фронт покажет «неизвестно»)
  async getBrskBinding (placeId) {
    const res = await this.webApi.get(this.url + 'places/' + placeId + '/brsk')
    const data = unwrapEnvelope(res)
    return data && typeof data.bound === 'boolean' ? data : null
  }

  // -> {ok:true, data:{api_key_mask}} | {ok:false, error}
  async bindBrsk (placeId, apiKey) {
    const res = await this.webApi.post(this.url + 'places/' + placeId + '/brsk/bind', { api_key: apiKey })
    const data = unwrapEnvelope(res)
    return data ? { ok: true, data: data } : { ok: false, error: envelopeError(res) || 'Ошибка запроса' }
  }

  // -> {ok:true, data:{api_key_mask}} | {ok:false, error}
  async replaceApiKey (placeId, apiKey) {
    const res = await this.webApi.post(this.url + 'places/' + placeId + '/brsk/replace-apikey', { api_key: apiKey })
    const data = unwrapEnvelope(res)
    return data ? { ok: true, data: data } : { ok: false, error: envelopeError(res) || 'Ошибка запроса' }
  }
}
